import { render, staticRenderFns } from "./Opinion.vue?vue&type=template&id=2f0b57e6&scoped=true"
import script from "./Opinion.vue?vue&type=script&lang=js"
export * from "./Opinion.vue?vue&type=script&lang=js"
import style0 from "./Opinion.vue?vue&type=style&index=0&id=2f0b57e6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0b57e6",
  null
  
)

export default component.exports